import React, { useState } from 'react';
import moment from 'moment';
// CCOMPs
import {
  Button,
  ButtonEmpty,
  FlexGroup,
  FlexItem,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalHeaderTitle,
  notification,
  Outline,
  Radio,
  RadioGroup,
  Text,
} from '@antoree/ant-ui';
// TYPEs
import { IAbsent, IRequestingReschedule } from 'types/IRequestingReschedule';

import styles from '../Notification.module.scss';
import { dateToFromNowDaily, dayOfWeekToString } from '../utils';

const { ArrowRightIcon } = Outline;

interface ReScheduleModalProps {
  onClose: () => void;
  absent: IAbsent;
  requestSchedule: IRequestingReschedule[];
  onUpdateApprovalReschedule: (data: IRequestingReschedule) => void;
  isLoading: boolean;
  responsiveSchedule: string;
}

const ReScheduleModal: React.FC<ReScheduleModalProps> = ({
  onClose,
  requestSchedule,
  absent,
  onUpdateApprovalReschedule,
  isLoading,
  responsiveSchedule,
}) => {
  const [selectedSchedule, setSelectedSchedule] = useState<
    IRequestingReschedule | any
  >();
  const {
    timeStartedAt,
    timeEndedAt,
    student,
    course,
    dateOccurredAt,
  } = absent;
  const { displayName } = student;
  const { title } = course;

  const radios =
    requestSchedule?.length > 0
      ? requestSchedule
          ?.map(item => {
            const { id, timeFrom, timeTo, dateTimeFrom } = item;
            const dayOfWeek = moment(dateTimeFrom).isoWeekday();
            return {
              id: `${id}`,
              label: (
                <>
                  <p>
                    {dayOfWeekToString(dayOfWeek - 1)}, &nbsp;
                    {moment(dateTimeFrom).format('YYYY-MM-DD')} at &nbsp;
                    {timeFrom} - {timeTo}
                  </p>
                  <p className="text-primary">
                    {dateToFromNowDaily(dateTimeFrom)}
                  </p>
                </>
              ),
            };
          })
          .concat({
            id: '0',
            label: <p>I cannot schedule any of the sessions above</p>,
          })
      : [];
  const onSelectSchedule = (id: number | string) => {
    const schedule = radios.find(item => item.id === id);
    setSelectedSchedule(schedule);
  };

  return (
    <Modal onClose={onClose} maxWidth="697px" style={{ width: '697px' }}>
      <ModalHeader>
        <ModalHeaderTitle>
          <h4 className="font-bold">Reschedule</h4>
        </ModalHeaderTitle>
      </ModalHeader>
      <ModalBody>
        <FlexGroup>
          <FlexItem>
            <span className="text-danger">Unscheduled</span>
            <p>
              {timeStartedAt} - {timeEndedAt}
            </p>
            <p>{moment(dateOccurredAt).format('dddd, DD/MM/YYYY')}</p>
            <div className="flex mt-2 gap-10">
              <div>
                <p>Student</p>
                <p className="font-semibold">{displayName}</p>
              </div>
              <div>
                <p>Course</p>
                <p className="font-semibold">{title}</p>
              </div>
            </div>
          </FlexItem>
          <FlexItem>
            {radios.length > 0 && (
              <div>
                <p>
                  <ArrowRightIcon className={styles.arrowRightIcon} />
                  <span className="text-primary">Suggested</span>
                </p>
                <RadioGroup
                  options={radios}
                  idSelected={String(selectedSchedule?.id)}
                  onChange={id => {
                    onSelectSchedule(id);
                  }}
                  name="student-type"
                />
              </div>
            )}
            {responsiveSchedule && (
              <div>
                <p>
                  <ArrowRightIcon className={styles.arrowRightIcon} />
                  <span className="text-primary">Changed to</span>
                </p>
                <Radio
                  id=""
                  checked={true}
                  onChange={() => {}}
                  label={moment(responsiveSchedule).format('dddd DD/MM/YYYY')}
                />
              </div>
            )}
          </FlexItem>
        </FlexGroup>
      </ModalBody>
      <ModalFooter className="justify-between">
        <ButtonEmpty onClick={onClose} color="text">
          Huỷ
        </ButtonEmpty>
        <Button
          fill
          color="primary"
          isLoading={isLoading}
          onClick={() => {
            if (!selectedSchedule) {
              notification.error({
                title: <p>Update fail</p>,
                text: <p>Please choose at least 1 slot schedule</p>,
              });
              return;
            }
            onUpdateApprovalReschedule(selectedSchedule);
          }}
        >
          <Text className="text-white">Tiếp tục</Text>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ReScheduleModal;
